module.exports = __webpack_public_path__ + "media/application/images/icons/thumbup-solid-67a79bb0119b64734b8fb3f20142d551.svg";